import React, { useState } from "react";
import { Range, getTrackBackground } from "react-range";
import { t } from "../../../utilities/translator";
import { scrollToResults } from "../../../utilities/helpers";

export default function FlightDurationMobile(props) {
  const { duration, handleChange } = props;
  const name = t('secondaryFilter.flightDuration');

  const { activeTime, minTime, maxTime } = duration;

  const [localState, setLocalState] = useState([activeTime / 60]);
  const isRtl = document.querySelector('html').getAttribute('dir') === 'rtl'

  const onChangeRange = (values) => {
    handleChange({ activeTime: values[0] * 60, minTime, maxTime });
    setLocalState(values);
    scrollToResults();
  }

  const renderTrack = ({ props, children }) => (
    <div className="track-wrap">
      <div
        {...props}
        className="track-line"
        style={{
          ...props.style,
          background: getTrackBackground({
            values: localState.map((item) => item * 60),
            colors: ["#73777C", "#D6D6D7"],
            min: minTime,
            max: maxTime,
            rtl: isRtl
          })
        }}
      >
        {children}
      </div>
    </div>
  )

  const renderThumb = ({ props }) => (
    <div
      {...props}
      style={{ ...props.style }}
      className="slider-thumb"
    >
      <div className="slider-line" />
      <div className="slider-line" />
      <div className="slider-line" />
    </div>
  )

  return (
    <div className="filter-item">
      <p className="filter-item__name">
        <span>{name}</span>
      </p>
      <div className="filter-body" style={{ width: "100%" }}>
        <div className="duration__wrap">
          <Range
            step={1}
            min={minTime / 60}
            max={maxTime / 60}
            values={localState}
            rtl={isRtl}
            onChange={onChangeRange}
            renderTrack={renderTrack}
            renderThumb={renderThumb}
          />
        </div>

        <div className="duration__range-values">
          <div className="duration__range-min">
            <div className="duration__label">
              {t("secondaryFilter.under")}
            </div>
            <div className="duration__value">
              {localState[0]}{" "}
              <span>{t("secondaryFilter.hours_plural", { count: localState[0] } ) }</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
